import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = (goal) =>
  api.get("/products", { params: goal ? { goal } : {} }).then((r) => r.data.products);

export const fetchProduct = (handle) =>
  api.get(`/products/${handle}`).then((r) => r.data);

export const fetchGoals = () => api.get("/goals").then((r) => r.data);

export const fetchBundleTiers = () => api.get("/bundle/tiers").then((r) => r.data);

export const fetchStacks = () => api.get("/stacks").then((r) => r.data.stacks);

export const fetchStack = (slug) => api.get(`/stacks/${slug}`).then((r) => r.data);

export const fetchBankDetails = () => api.get("/bank-details").then((r) => r.data);

export const createBankTransfer = (shipping, items, complianceAck = false) =>
  api
    .post("/payments/bank-transfer", {
      shipping,
      items: items.map((i) => ({ handle: i.handle, quantity: i.quantity, variant: i.variant || null })),
      client_id: getClientId(),
      compliance_ack: complianceAck,
      promo_code: getSpin()?.code || null,
    })
    .then((r) => r.data);

export const bundleDiscount = (distinctCount, tiers = []) => {
  let percent = 0;
  tiers.forEach((t) => {
    if (distinctCount >= t.min_items) percent = t.percent;
  });
  return percent;
};

export const nextTier = (distinctCount, tiers = []) =>
  tiers.find((t) => distinctCount < t.min_items) || null;

export const createCheckout = (items, complianceAck = false) =>
  api
    .post("/payments/checkout", {
      items,
      origin_url: window.location.origin,
      client_id: getClientId(),
      compliance_ack: complianceAck,
    })
    .then((r) => r.data);

export const createCryptoCheckout = (items, complianceAck = false, email = "") =>
  api
    .post("/payments/crypto/checkout", {
      items,
      origin_url: window.location.origin,
      client_id: getClientId(),
      compliance_ack: complianceAck,
      email,
    })
    .then((r) => r.data);

export const fetchPaymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const money = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n);

const CLIENT_KEY = "rsa_client_id";
export const getClientId = () => {
  let id = localStorage.getItem(CLIENT_KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `c_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(CLIENT_KEY, id);
  }
  return id;
};

export const fetchLoyalty = () =>
  api.get(`/loyalty/${getClientId()}`).then((r) => r.data);

export const fetchSavedStacks = () =>
  api.get(`/saved-stacks/${getClientId()}`).then((r) => r.data.stacks);

export const saveStack = (name, items) =>
  api.post("/saved-stacks", { client_id: getClientId(), name, items }).then((r) => r.data);

export const deleteSavedStack = (id) =>
  api.delete(`/saved-stacks/${getClientId()}/${id}`).then((r) => r.data);

export const fetchPairings = (handles) =>
  api.get(`/pairings?handles=${handles.join(",")}`).then((r) => r.data.products);



const SPIN_KEY = "rsa_spin_v1";

export const spinWin = () =>
  api.post("/spin", { client_id: getClientId() }).then((r) => r.data);

export const getSpin = () => {
  try {
    const s = JSON.parse(localStorage.getItem(SPIN_KEY));
    if (s && s.code && new Date(s.expires_at).getTime() > Date.now()) return s;
  } catch {
    /* ignore */
  }
  return null;
};

export const setSpin = (s) => localStorage.setItem(SPIN_KEY, JSON.stringify(s));

export const clearSpin = () => localStorage.removeItem(SPIN_KEY);
